import React from "react";
import styled from "styled-components";
import {
  Content,
  MainContainer,
} from "../../Pages/OnBoarding/components/Common/Common";
import AnimationEvent from "../../assets/loading-new.gif";

const StyledContent = styled(Content)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Ensures full height */
  text-align: center; /* Centers text */
`;

const CalculateFinancialScore = () => {
  return (
    <MainContainer style={{ backgroundColor: "#F4F3EF", minHeight: "100vh" }}>
      <StyledContent>
        <img src={AnimationEvent} alt="Loading Animation" />
        <div style={{ marginTop: "20px", fontSize: "25px" }}>
          <p>
            HDFC Life is calculating your <br /> Comprehensive Insurance{" "}
            <br /> Eligibility Score
          </p>
        </div>
      </StyledContent>
    </MainContainer>
  );
};

export default CalculateFinancialScore;
